import { RANDOM_STRING } from '../../constants/other';

export const generateString = (length) => {
  let result = '';
  const characters = RANDOM_STRING;
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }

  return result;
};
